import { Box, Stack } from "@mui/material";
import MDEditor from "@uiw/react-md-editor";
import React, { useState } from "react";

import { BaseImage } from "components/common/BaseImage";
import { ImageLightBox } from "components/ImageLightBox";
import { Note } from "types/notes";
import { generateImageUrl } from "utils/generateImageUrl";

interface PinnedNoteItemProps {
  note: Note;
}

export function PinnedNoteItem(props: PinnedNoteItemProps) {
  const { note } = props;

  const [isImageLightBoxOpen, setIsImageLightBoxOpen] = useState(false);

  return (
    <Stack className="bg-white p-3.5 rounded-md text-start">
      {note.image_id && (
        <>
          <Box
            className="w-fit mb-2"
            onClick={() => setIsImageLightBoxOpen(true)}
            onKeyDown={() => setIsImageLightBoxOpen(true)}
            role="presentation"
          >
            {/* This show an image inside a note uploaded by the user, so, no canvas required here */}
            <BaseImage width="170px">
              <img
                alt="example"
                src={generateImageUrl(undefined, note.image_id)}
                className="h-[110px] w-[170px] object-cover object-center transition-all cursor-pointer"
              />
            </BaseImage>
          </Box>
          <ImageLightBox
            imageSource={generateImageUrl(undefined, note.image_id)}
            isOpen={isImageLightBoxOpen}
            onClose={() => setIsImageLightBoxOpen(false)}
          />
        </>
      )}
      <MDEditor.Markdown
        source={note.content}
        className="text-black bg-transparent"
        style={{ whiteSpace: "pre-wrap" }}
      />
    </Stack>
  );
}
